export default __webpack_public_path__ + "static/media/Sunday_08.8f90aba6.png";